import { FM_FORM_STATUSES, FormStatusCode } from '../typings'

export const getStatusFromStatusCode = (statusCode: FormStatusCode) => {
  switch (statusCode) {
    case 0:
      return FM_FORM_STATUSES.Draft
    case 1:
      return FM_FORM_STATUSES.InProgress
    case 2:
      return FM_FORM_STATUSES.OutForSignature
    case 3:
      return FM_FORM_STATUSES.Signed
    case 4:
      return FM_FORM_STATUSES.Complete
    case 5:
      return FM_FORM_STATUSES.Canceled
    case 6:
      return FM_FORM_STATUSES.Declined
  }
}
